import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";







'use strict';


const g = typeof global === 'undefined' ? window : global;
const handlebars = g.Handlebars || Handlebars;






function htmlDecode(input) {
  return typeof input !== 'string' ? input : input
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
}










function extract(markup, regexp, object, prop, join = '\n') {
  const config = object;
  const inlined = [];

  const extracted = markup.replace(regexp, ($0, $1) => {
    const trimmed = $1.trim();
    if (trimmed) inlined.push(trimmed);
    return '';
  });

  config[prop] = `${config[prop] || ''}${join}${inlined.join(join)}`;
  return extracted;
}






function generateModuleParameterDataAttribute(context) {
  const moduleParameters = {};


  context.module.moduleParams.forEach((param) => {
    moduleParameters[param.name] = Object.hasOwnProperty.call(context.module || {}, param.name)
      ? context.module[param.name]
      : param.default;
  });

  return `data-module-parameters='${JSON.stringify(moduleParameters)}'`;
}






function maybeJsonParse(value) {
  try { return JSON.parse(value); } catch (e) { return value; }
}







function recursivelyRenderExpressions(input, context) {
  if (!input || typeof input !== 'object') return input;

  const object = input;
  Object.keys(object).forEach((key) => {
    const value = object[key];



    if (typeof value === 'string' && value.indexOf('{{') > -1) {
      object[key] = maybeJsonParse(htmlDecode(handlebars.compile(value)(context)));
    } else {
      object[key] = recursivelyRenderExpressions(object[key], context);
    }
  });

  return object;
}











function renderModule(env, language, siteConfig, pageConfig, platformModule, rules) {
  const config = platformModule.config;
  const dataSources = platformModule.dataSources || {};

  const moduleName = config.moduleName;
  const moduleVersion = config.version;



  const context = {
    env,
    language,
    moduleName,
    global: siteConfig.global[language],
    page: pageConfig.parameters,
    site: siteConfig.params,
    module: platformModule.params,
    children: platformModule.children,
    footnotes: pageConfig.footnotes,
  };



  Object.keys(dataSources).forEach((name) => {
    context[name] = dataSources[name][language];
  });



  recursivelyRenderExpressions(platformModule.params || {}, context);


  const tag = config.tag || 'div';
  const id = platformModule.id || config.id || '';


  context.module.containerID = id;


  const nameSpace = config.nameSpace || moduleName;
  const modNameSpaceVersion = `${nameSpace}-class-v-${moduleVersion}`.replace(/\./g, '-');

  let dataInit = '';
  let spaModuleInit = '';
  let dataOptions = '';

  if (config.data && typeof config.data.init === 'string') {
    dataInit = `data-init="${config.data.init}"`;
    spaModuleInit = 'spa-module-init';
  }


  if (context.module.data && typeof context.module.data.options === 'object') {
    dataOptions = `data-options='${JSON.stringify(context.module.data.options)}'`;
  }


  const group = (!platformModule.primaryloadType && pageConfig.hasSecondary) ? 'secondary' : 'primary';
  const dataSpartaLoad = `data-sparta-load="${group}"`;
  const dataRef = `data-module-ref=${platformModule.name}`;
  (context.module.load || {}).group = group;



  const wrapper = handlebars.compile(
    `\n\n<${tag} ${id ? `id="${id}"` : ''} data-component="module" ` +
    `data-module="${moduleName}" data-module-container="3.1.4" data-version="${moduleVersion}" ` +
    `${dataSpartaLoad} ${dataRef} ${dataOptions} ${dataInit} ${generateModuleParameterDataAttribute(context)} ` +
    `class="${modNameSpaceVersion} ${nameSpace} ${spaModuleInit}">`)(context);


  let html = '';
  if (!rules[moduleName] || rules[moduleName].indexOf('addModule') === -1) {
    html = handlebars.compile(`{{>${moduleName}}}`)(context);


    if (siteConfig.params.inlineCode && !platformModule.isOnDemandModule) {
      html = extract(html, /<script>([\s\S]*?)<\/script>/g, pageConfig, 'inlineJS', ';');
      html = extract(html, /<style>([\s\S]*?)<\/style>/g, pageConfig, 'inlineCSS', '\n');
    }
  }

  return `${wrapper}\n${html}\n</${tag}>\n\n`;
}

const helpers = {










  moduleContainer(siteConfig, pageConfig, language, env, assetPath, moduleArray) {
    return moduleArray
      .map(mod => helpers.composeModule(siteConfig, pageConfig, language, env, assetPath, mod))
      .join('');
  },











  composeModule(siteConfig, pageConfig, language, env, assetPath, platformModule) {
    if (!siteConfig.global) throw new Error('The site\'s global configuration is undefined.');

    const rules = {};
    const childModules = platformModule.childModules;


    if (Array.isArray(platformModule.rules)) {
      platformModule.rules.forEach((rule) => {
        rules[platformModule.config.moduleName] = rule.actions.map(action => action.type);
      });
    }


    if (Array.isArray(childModules)) {
      const children = {};
      childModules.forEach((childModule) => {
        const id = childModule.id
          || childModule.config.shortName
          || childModule.config.id
          || childModule.config.moduleName;

        children[id] = renderModule(env, language, siteConfig, pageConfig, childModule, rules);
      });

      Object.assign(platformModule, { children });
    }


    return renderModule(env, language, siteConfig, pageConfig, platformModule, rules);
  },
};


module.exports.register = (Handlebars) => {
  Object.keys(helpers).forEach(key => Handlebars.registerHelper(key, helpers[key]));
};

module.exports.helpers = helpers;
